<nb-card>
  <nb-card-header
    >{{ header }}
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <p *ngIf="description">{{ description }}</p>
    <form [formGroup]="diaForm">
      <div class="form-group">
        <input
          nbInput
          fullWidth
          formControlName="title"
          placeholder="Nhập tiêu đề"
          class="form-control"
          [ngClass]="{
            'form-control-danger':
              diaForm.invalid && (diaForm.dirty || diaForm.touched)
          }"
          [(ngModel)]="title"
        />
      </div>

      <div class="form-group">
        <label class="label">Trạng thái</label>
        <nb-select
          hero
          shape="round"
          size="tiny"
          [status]="
            status == '1' ? 'success' : status == '0' ? 'info' : 'warning'
          "
          placeholder="Chọn trạng thái"
          formControlName="status"
          [(ngModel)]="status"
        >
          <nb-option value="1">Xuất bản</nb-option>
          <nb-option value="0">Đang thực hiện</nb-option>
          <nb-option value="-1">Ẩn nội dung</nb-option>
        </nb-select>
      </div>

      <div
        *ngIf="mode == 'privacy' && (user.admin || user.moderator)"
        class="form-group"
      >
        <label class="label">Chia sẻ</label>
        <nb-radio-group [(ngModel)]="privacy" formControlName="privacy">
          <nb-radio [checked]="privacy" [value]="true">
            Phải tham gia lớp học mới xem được
          </nb-radio>
          <nb-radio [checked]="!privacy" [value]="false">
            Miễn phí, không cần tham gia lớp
          </nb-radio>
        </nb-radio-group>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="primary"
      (click)="submit()"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
    >
      Lưu
    </button>
  </nb-card-footer>
</nb-card>
